import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import PreLoader from 'components/PreLoader/PreLoader.react';
import SegmentSelect from 'components/SegmentSelect/SegmentSelect.react';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import moment from 'moment';
import { numeral } from 'lib/helpers';
import BarChart from 'components/Charts/BarChart.react';
import chartStyles from 'components/Charts/Charts.scss';

import settingsStyles from 'dashboard/Settings/Settings.scss';
import styles from '../CDN.scss';

export default class Overview extends Component {
  constructor(props) {
    super();

    this.state = {
      loading: true,
      segmentType: 'bytes',
      segmentTime: '30',
      newData: {},
    }
  }

  componentDidMount() {
    this.changeType('bytes');
  }

  changeType(type) {
    if(type === 'bytes') {
      this.showBytes(type);
    } else {
      this.showHits(type);
    }
  }

  showBytes(type) {
    SashiDo.CDNServicesMetricsBytes({
      ids: [this.props.params.cdnId],
      from: moment().subtract(1, 'days').unix(),
      to: moment().unix(),
      by: 'hour',
    }).then((data) => {
      this.setState({
        segmentType: 'bytes',
        dataFormat: '0b',
        originalBytesData: data,
      });

      return data;
    }).then((data) => {
      this.resolutionChange(data, type);
    });
  }

  showHits(type) {
    SashiDo.getCDNMetricsHits({
      ids: [this.props.params.cdnId],
      from: moment().subtract(30, 'days').unix(),
      to: moment().unix(),
      by: 'day',
    }).then((data) => {
      this.setState({
        segmentType: 'hits',
        dataFormat: '0a',
        originalHitsData: data,
      });

      return data;
    }).then((data) => {
      this.resolutionChange(data, type);
    });

  }

  resolutionChange(data, type, time) {
    if(!data) {
      data = this.state.segmentType === 'bytes' ? this.state.originalBytesData : this.state.originalHitsData;
    }

    if(!type) {
      type = this.state.segmentType;
    }

    if(!time) {
      time = this.state.segmentTime;
    }

    const labels = [];
    const datasets = [];

    data.forEach((item) => {
      labels.push(moment.unix(item.timestamp).format('MMM DD'));
      datasets.push(item[type] || 0);
    });

    this.setState({
      loading: false,
      segmentTime: time,
      segmentType: type,
      newData: {
        labels: labels.slice(0, time),
        datasets: [
          {
            values: datasets.slice(0, time),
          }
        ]
      },
    });
  }

  render() {
    return (
      <PreLoader loading={this.state.loading}>
        <div className={settingsStyles.holder}>
          <div className={styles.holder}>
            <h2>{this.props.CDNServiceCurrentSiteData && this.props.CDNServiceCurrentSiteData.domains[0]}</h2>
            {
              Object.keys(this.state.newData).length !== 0 &&
                <BarChart
                  title={`${this.state.segmentType === 'bytes' ? 'Bandwidth' : 'Requests'} Usage`}
                  unit={'Requests'}
                  dataFormat={this.state.dataFormat}
                  data={this.state.newData}
                  height={200}
                  segmentTypeComponent={
                    <SegmentSelect
                      labels={['Bandwidth', 'Requests']}
                      values={['bytes', 'hits']}
                      current={this.state.segmentType}
                      onChange={(type) => {
                        this.changeType(type);
                      }} />
                  }
                  segmentTimeComponent={
                    <SegmentSelect
                      labels={['7 Days', '14 Days', '30 Days']}
                      values={['7', '14', '30']}
                      current={this.state.segmentTime}
                      onChange={(time) => {
                        this.resolutionChange(null, null, time);
                      }} />
                  }
                  colors={['#0092ff']}
                />
            }

          </div>
        </div>
      </PreLoader>
    );
  }
}
